import { createConfig, extendConfig } from '@platform-shared/config';

/**
 * VTC-specific configuration that extends and overrides the shared config
 */
const vtcConfig = {
  // VTC-specific settings
  mode: 'remote',
  authentication: {
    localStorageToken: 'sp_token',
    localStorageRoomSid: 'sp_room',
  },
  featureFlags: {
    enableNewUI: true,
    enableBetaFeatures: false,
  },
  modes: {
    checkin: {
      drawerWidth: '300px',
    },
    focus: {
      drawerWidth: '60%',
    },
    settings: {
      drawerWidth: '500px',
    },
    options: {
      drawerWidth: '400px',
    },
  },
};

/**
 * Merge the shared config with the VTC-specific config
 * The VTC config will override any shared config values with the same keys
 */
const baseConfiguration = createConfig(import.meta.env.VITE_MODE);
const config = extendConfig('vtc', vtcConfig, baseConfiguration);

export const API_PATHS = {
  LIST_ROOMS: '/v1/hybrid/locations/rooms',
  ROOMS: '/v1/hybrid/locations/rooms/:roomSid',
  ACTIVE_PROCTORS: '/v1/hybrid/locations/rooms/:roomSid/proctors`',
  EXIT_ROOM:
    '/v1/proctors/:proctorAccountSid/rooms/:roomSid/proctors/:proctorUserSid',
  LOGIN: '/v1/proctors/login',
  TTL: '/v1/ttl',
  EXTEND_TTL: '/v1/check',
  TOKEN_PERMISSIONS: '/v1/permissions',
  PROCTOR_ACCOUNT: '/v1/proctors/:accountSid',
  ANNOTATIONS:
    '/v1/installs/:installSid/exams/:examSid/sessions/:sessionSid/annotations',
  ROOMS_FOR_TRANSFER:
    '/v1/hybrid/installs/:installSid/exams/:examSid/sessions/:sessionSid/availableRoomsToTransfer?proctorRoomSid=:roomSid',
  TRANSFER_SESSION:
    '/v1/hybrid/installs/:installSid/exams/:examSid/sessions/:sessionSid/transferStudentToRoom?proctorRoomSid=:roomSid&requestingRoomSid=:requestingRoomSid&isInReview=:isInReview',
};

export const ROUTES = {
  LOGIN: '/',
  AUTO_LOGIN: '/vtc',
  ROOMS: '/rooms',
  ROOM: '/rooms/:roomSid',
  CHECKIN_FOCUS: '/rooms/:roomSid/checkin/:sessionSid',
  SESSION_FOCUS: '/rooms/:roomSid/focus/:sessionSid',
  SETTINGS: '/rooms/:roomSid/settings',
  CHECKIN: '/rooms/:roomSid/checkin',
  SCHEDULE: '/rooms/:roomSid/schedule',
  OPTIONS: '/rooms/:roomSid/options',
};

export default config;
